import ajax from './index'


export function deleteHotGoods(data) {
  return ajax.post('/admin/product/self_product/share_del',data)
}

export function getHotGoodsList(url) {
  return ajax.get(
    '/admin/product/self_product/share_goods?' + url
  )
}
export function getHotGoodsDetail(data) {
  return ajax.post('/admin/product/self_product/share_details',data)
}

